'use client';

import { useIntl } from 'react-intl';

import { BypassLink } from '@packages/shared/src/ui/BypassBlock/BypassLink';
import { bypassBlockMessages } from './messages';
import {
  BYPASS_TARGET_AFTER_MAIN_NAV,
  BYPASS_TO_MAIN_NAV,
  BYPASS_TO_MAIN_SECTION,
} from './Header.ids';

export const BypassNavigationLink = () => {
  const { formatMessage } = useIntl();

  return (
    <BypassLink
      linkText={formatMessage(bypassBlockMessages.bypassSlotsAndMainNavigation)}
      anchorId={BYPASS_TARGET_AFTER_MAIN_NAV}
      // BypassBlockButton in the icons div wih overflow-hidden, causes unexpected layout shifts and clips the skipping button as well
      className="hidden focus-visible:left-[40vw] max-md:focus-visible:left-[5vw] max-md:focus-visible:px-2 lg:inline"
    />
  );
};

export const BypassHeaderAndSearchLinks = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="h-0 w-0 overflow-hidden focus-within:flex focus-within:h-auto focus-within:w-auto focus-within:items-center focus-within:justify-center focus-within:gap-3 focus-within:py-3">
      {/* this bypass link is used only for the desktop app version */}
      <BypassLink
        className="focus-visible:bg-color-grey focus-visible:border-color-info text-color-info-contrasttext border-color-grey-dark relative h-auto w-auto rounded border-2 border-solid p-2.5 focus-visible:top-0 focus-visible:left-0 max-lg:hidden"
        linkText={formatMessage(bypassBlockMessages.bypassLogoAndSearchfield)}
        anchorId={BYPASS_TO_MAIN_NAV}
        skipScrollIntoView
      />
      <BypassLink
        className="focus-visible:bg-color-grey focus-visible:border-color-info border-color-grey-dark text-color-info-contrasttext relative h-auto w-auto rounded border-2 border-solid p-2.5 focus-visible:top-0 focus-visible:left-0"
        linkText={formatMessage(bypassBlockMessages.bypassMainNavigationAndUsp)}
        anchorId={BYPASS_TO_MAIN_SECTION}
      />
    </div>
  );
};
